// src/components/MaintenancePanelSwitcher/MaintenancePanelSwitcher.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUser, setUser } from "../../services/apiService";
import "./MaintenancePanelSwitcher.css";

const MaintenancePanelSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const currentUser = getUser();

  const handleAdminClick = () => {
    if (currentUser) {
      const adminUser = {
        ...currentUser,
        role: "admin",
        role_name: "Admin",
        role_id: 1,
      };
      setUser(adminUser);
      localStorage.setItem("user", JSON.stringify(adminUser));
      navigate("/admin");
    }
    setIsOpen(false);
  };

  const handleEmployeeClick = () => {
    if (currentUser) {
      const employeeUser = {
        ...currentUser,
        role: "employee",
        role_name: "User",
        role_id: 2,
      };
      setUser(employeeUser);
      localStorage.setItem("user", JSON.stringify(employeeUser));
      navigate("/employee");
    }
    setIsOpen(false);
  };

  // Sadece maintenance admin kullanıcıları için göster
  if (
    !currentUser ||
    (currentUser.role_name !== "maintenance_admin" && currentUser.role_id !== 3)
  ) {
    return null;
  }

  return (
    <div className="maintenance-panel-switcher">
      <button
        className="maintenance-panel-switcher-btn"
        onClick={() => setIsOpen(!isOpen)}
      >
        <i className="fas fa-exchange-alt"></i>
        <span>Panel Değiştir</span>
        <i className={`fas fa-chevron-${isOpen ? "up" : "down"}`}></i>
      </button>
      {isOpen && (
        <div className="maintenance-panel-switcher-dropdown">
          <button className="dropdown-item" onClick={handleAdminClick}>
            <i className="fas fa-user-shield"></i>
            <span>Yönetici Paneli</span>
          </button>
          <button className="dropdown-item" onClick={handleEmployeeClick}>
            <i className="fas fa-user"></i>
            <span>Çalışan Paneli</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default MaintenancePanelSwitcher;
